import React from "react";
import styles from "../../Appointments/Appointments.module.scss";
import crossIcon from "assets/images/cross.svg";

export default function RolePopup({
  handlePopupToggle,
  position,
  list,
  isForEvent = false,
}) {
  return (
    <div
      className={`${styles.schedular_popup_invite_view} ${
        isForEvent ? "w-100" : ""
      }`}
      style={{
        top: position?.top,
        right: position?.right,
        position: "absolute",
      }}
    >
      <span
        className={`${styles.close_btn_absolute_position}`}
        onClick={handlePopupToggle}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <div
        className={styles.container_box_roles}
        style={{ maxHeight: list?.length > 3 ? "300px" : "124px" }}
      >
        {list?.length > 0 &&
          list.map((val) => (
            <div key={val?.id} className={styles.office_name_wrapper}>
              <p className={styles.office_name}>{val?.name}</p>
            </div>
          ))}
      </div>
    </div>
  );
}
